import { registerMessages } from "../../../i18n/runtime";
import { purchaseEn } from "./messages.en";
import { purchaseEs } from "./messages.es";
registerMessages("en", purchaseEn);
registerMessages("es", purchaseEs);
